export default __webpack_public_path__ + "static/media/star-group.9397cefe.gif";